__turbopack_context__.v({
  "additional_info": "soT1vq_additional_info",
  "blogsPagePaginationWrapper": "soT1vq_blogsPagePaginationWrapper",
  "contentContainer": "soT1vq_contentContainer",
  "contentLink": "soT1vq_contentLink",
  "date": "soT1vq_date",
  "detail": "soT1vq_detail",
  "displayUrl": "soT1vq_displayUrl",
  "excerpt": "soT1vq_excerpt",
  "info": "soT1vq_info",
  "listImage": "soT1vq_listImage",
  "resultItem": "soT1vq_resultItem",
  "resultsList": "soT1vq_resultsList",
  "resultsSection": "soT1vq_resultsSection",
  "sectionTitle": "soT1vq_sectionTitle",
  "title": "soT1vq_title",
  "type": "soT1vq_type",
});
